import React from 'react';
import {useTranslation} from 'react-i18next';
import {ImportSlideTabEnum} from '../../../../../incase-domain/common/importTab.enum';
import Button from '../../../../../incase-domain/components/button/Button';

interface ImportSlideTabsProps {
    activeTab: ImportSlideTabEnum;
    setActiveTab: (tabName: ImportSlideTabEnum) => void;
}

function ImportSlideTabs(props: ImportSlideTabsProps): JSX.Element {
    const {activeTab, setActiveTab} = props;
    const {t} = useTranslation();
    return (
        <div className="c-importSlidesModal__importSlidesTab u-mt-2">
            <div className="c-importSlidesModal__importSlidesTab_tab">
                <Button
                    size="sm"
                    color="secondary"
                    variant={activeTab === ImportSlideTabEnum.ALL ? 'solid' : 'soft'}
                    key={ImportSlideTabEnum.ALL}
                    onClick={() => {
                        setActiveTab(ImportSlideTabEnum.ALL);
                    }}
                >
                    {t('editorPage.importSlidesModal.allSlides')}
                </Button>
            </div>
            <div className="c-importSlidesModal__importSlidesTab_tab u-ml-1">
                <Button
                    size="sm"
                    color="secondary"
                    variant={activeTab === ImportSlideTabEnum.BOOKMARKED ? 'solid' : 'soft'}
                    key={ImportSlideTabEnum.BOOKMARKED}
                    onClick={() => {
                        setActiveTab(ImportSlideTabEnum.BOOKMARKED);
                    }}
                >
                    {t('editorPage.importSlidesModal.bookmarkedSlides')}
                </Button>
            </div>
        </div>
    );
}

export default ImportSlideTabs;
